// extracted by mini-css-extract-plugin
export default {"card":"WkGQCyHe7uQbH9h26iu0","listItem":"tX5w8Jg9wHYj2Hw2899j"};